import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Carousel from '@spothero/ui/carousel';
import CarouselSlides from '@spothero/ui/carousel-slides';
import CarouselSlide from '@spothero/ui/carousel-slide';
import NewsVideo from './NewsVideo';

const videos = [
    {
        title: 'Google Assistant + SpotHero',
        imageID: 'googleassistant-video',
        subtitle: 'Voice-Activated Parking',
        description: `
            <em>"Hey Google, book parking"</em>
            <br />
            <br />
            Customers can use voice commands to book parking with SpotHero via the Assistant and in-car with Android Auto.
        `,
        videoURL:
            'https://www.youtube.com/watch?v=m6hF1uvcaTA&feature=youtu.be',
    },
    {
        title: 'Waze + SpotHero',
        imageID: 'waze-video',
        subtitle: 'Improved Urban Navigation',
        description: `
            SpotHero, Waze, and the City of Chicago teamed up to outsmart traffic.
            <br />
            <br />
            By installing 450 Waze Beacons, we improved navigation for millions of drivers along 5 miles of Chicago&apos;s multi-level roads.
        `,
        videoURL: 'https://youtu.be/homytHQhTKY',
    },
];

const NewsVideos = ({className}) => {
    return (
        <>
            <Carousel
                className={classNames(
                    'NewsVideos',
                    'NewsVideos-carousel',
                    className
                )}
                showDots
                transition="none"
            >
                <CarouselSlides>
                    {videos.map(video => (
                        <CarouselSlide key={video.title}>
                            <NewsVideo className="NewsVideos-item" {...video} />
                        </CarouselSlide>
                    ))}
                </CarouselSlides>
            </Carousel>
            <div
                className={classNames(
                    'NewsVideos',
                    'NewsVideos-static',
                    className
                )}
            >
                {videos.map(video => (
                    <NewsVideo
                        className="NewsVideos-item"
                        key={video.title}
                        {...video}
                    />
                ))}
            </div>
        </>
    );
};

NewsVideos.propTypes = {
    className: PropTypes.string,
};

export default NewsVideos;
